"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collider = void 0;

var Enums_1 = require("../../../Enums");

var Utils_1 = require("../../../Utils");

var ParticlesInteractorBase_1 = require("../../../Core/ParticlesInteractorBase");

function bounce(p1, p2) {
  (0, Utils_1.circleBounce)((0, Utils_1.circleBounceDataFromParticle)(p1), (0, Utils_1.circleBounceDataFromParticle)(p2));
}

function destroy(p1, p2) {
  if (!p1.unbreakable && !p2.unbreakable) {
    bounce(p1, p2);
  }

  if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
    p1.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
    p2.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
    if (p1.getRadius() >= p2.getRadius()) {
      p2.destroy();
    } else {
      p1.destroy();
    }
  }
}

var Collider =
/*#__PURE__*/
function (_ParticlesInteractorB) {
  _inherits(Collider, _ParticlesInteractorB);

  function Collider(container) {
    _classCallCheck(this, Collider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Collider).call(this, container));
  }

  _createClass(Collider, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.collisions.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1) {
      var container = this.container;
      var pos1 = p1.getPosition();
      var radius1 = p1.getRadius();
      var query = container.particles.quadTree.queryCircle(pos1, radius1 * 2);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p2 = _step.value;

          if (p1 === p2 || !p2.options.collisions.enable || p1.options.collisions.mode !== p2.options.collisions.mode || p2.destroyed || p2.spawning) {
            continue;
          }

          var pos2 = p2.getPosition();

          if (Math.round(pos1.z) !== Math.round(pos2.z)) {
            continue;
          }

          var dist = (0, Utils_1.getDistance)(pos1, pos2);
          var radius2 = p2.getRadius();
          var distP = radius1 + radius2;

          if (dist <= distP) {
            this.resolveCollision(p1, p2);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "resolveCollision",
    value: function resolveCollision(p1, p2) {
      switch (p1.options.collisions.mode) {
        case Enums_1.CollisionMode.absorb:
          {
            this.absorb(p1, p2);
            break;
          }

        case Enums_1.CollisionMode.bounce:
          {
            bounce(p1, p2);
            break;
          }

        case Enums_1.CollisionMode.destroy:
          {
            destroy(p1, p2);
            break;
          }
      }
    }
  }, {
    key: "absorb",
    value: function absorb(p1, p2) {
      var container = this.container;
      var fps = container.fpsLimit / 1000;

      if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
        p1.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
        p2.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
        if (p1.getRadius() >= p2.getRadius()) {
          var factor = (0, Utils_1.clamp)(p1.getRadius() / p2.getRadius(), 0, p2.getRadius()) * fps;
          p1.size.value += factor;
          p2.size.value -= factor;

          if (p2.getRadius() <= container.retina.pixelRatio) {
            p2.size.value = 0;
            p2.destroy();
          }
        } else {
          var _factor = (0, Utils_1.clamp)(p2.getRadius() / p1.getRadius(), 0, p1.getRadius()) * fps;

          p1.size.value -= _factor;
          p2.size.value += _factor;

          if (p1.getRadius() <= container.retina.pixelRatio) {
            p1.size.value = 0;
            p1.destroy();
          }
        }
      }
    }
  }]);

  return Collider;
}(ParticlesInteractorBase_1.ParticlesInteractorBase);

exports.Collider = Collider;